import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { SpaceProps, space, variant } from 'styled-system';
import { StyledProps, Theme } from './Checkbox.types';

export const CheckboxContainer = styled.div<SpaceProps, Theme>`
  display: flex;
  align-items: center;
  margin: 8px;
  ${space}
`;

export const HiddenCheckbox = styled.input`
  display: none;
`;

export const CheckboxLabel = styled.label<SpaceProps, Theme>`
  margin-left: 12px;
  ${space}
`;

export const StyledCheckbox = styled.div<StyledProps, Theme>`
  display: flex;
  min-width: 24px;
  min-height: 24px;
  background: 'var(--color-neutral-0)';
  border-radius: 4px;
  border: 1px solid;
  border-color: 'var(--color-smoke)';
  ${variant({
    prop: 'mode',
    variants: {
      primary: {
        bg: 'var(--color-neutral-0)',
        borderColor: 'var(--color-smoke)',
        stroke: 'var(--color-green)',
      },
      secondary: {
        bg: 'var(--color-neutral-0)',
        borderColor: 'var(--color-smoke)',
        stroke: 'var(--color-green)',
      },
      warning: {
        bg: 'var(--color-neutral-0)',
        borderColor: 'vr(--color-honey)',
        stroke: 'var(--color-honey)',
      },
      success: {
        bg: 'var(--color-neutral-0)',
        borderColor: 'var(--color-green)',
        stroke: 'var(--color-green)',
      },
    },
  })}

  ${(props) =>
    props.isDisabled &&
    css({
      background: 'var(--color-neutral-15)',
    })}
`;

export default styled.div<StyledProps, Theme>``;
